
import React from 'react';
const Clock = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_6387_34723)">
            <path d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 5V10L13.3333 11.6667" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_6387_34723">
                <rect width="20" height="20" fill="transparent" />
            </clipPath>
        </defs>

    </svg>
);


export default Clock;
